import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function ButtonLoader() {
  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <CircularProgress
          // color="success"
          color="inherit"
          sx={{
            // color: '#fff',
            width: '30px !important',
            height: '30px !important',
          }}
        />
      </Box>
    </div>
  );
}

export default ButtonLoader;
